(function () {
  'use strict';
  if (window.LionDTFSizeGuide) {
    window.LionDTFSizeGuide.init(document);
    return;
  }
  var format = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function validate(data) {
    if (!data || data.units !== 'in' || !Array.isArray(data.sizes) || !data.sizes.length || !Array.isArray(data.placements) || !data.placements.length) throw new Error('Invalid size matrix');
    data.placements.forEach(function (placement) {
      ['width', 'height', 'offset'].forEach(function (metric) {
        if (!Array.isArray(placement[metric]) || placement[metric].length !== data.sizes.length || placement[metric].some(function (value) { return typeof value !== 'number' || !Number.isFinite(value) || value <= 0; })) throw new Error('Invalid measurements');
      });
    });
  }
  function draw(root, placement, measurement) {
    var sleeve = placement.id === 'sleeve';
    var chest = placement.id === 'leftchest' || placement.id === 'pocket';
    var back = placement.id === 'fullback' || placement.id === 'upperback';
    var width = Math.max(22, Math.min(132, measurement.width / 17 * 132));
    var height = Math.max(20, Math.min(187, measurement.height / 19.5 * 187));
    var x = chest ? 185 : (320 - width) / 2;
    var y = Math.min(295 - height, 48 + measurement.offset * 7);
    if (sleeve) { x = 47; y = 83; width = 25; height = 25; }
    var svg = '<svg viewBox="0 0 320 350" role="img" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M108 32 L132 26 Q160 51 188 26 L212 32 L283 77 L259 130 L228 114 L228 316 Q160 329 92 316 L92 114 L61 130 L37 77 Z" fill="#e8edf5" stroke="#bdcadd" stroke-width="2"/>' +
      '<path d="M132 26 Q160 59 188 26" fill="none" stroke="#bdcadd" stroke-width="3"/>' +
      '<path d="M108 32 L92 114 M212 32 L228 114" fill="none" stroke="#cbd5e3" stroke-width="2"/>' +
      '<rect x="' + x + '" y="' + y + '" width="' + width + '" height="' + height + '" rx="3" fill="#22489e" fill-opacity=".16" stroke="#22489e" stroke-width="2"/>';
    if (sleeve) {
      svg += '<line x1="79" y1="108" x2="79" y2="124" stroke="#d94f04" stroke-width="1.5" stroke-dasharray="3 2"/>' +
        '<text x="85" y="120" fill="#b54000" font-size="11" font-family="Arial,sans-serif">' + format.format(measurement.offset) + ' in from hem</text>';
    } else {
      var arrowX = chest ? x - 10 : x - 12;
      svg += '<line x1="' + arrowX + '" y1="47" x2="' + arrowX + '" y2="' + y + '" stroke="#d94f04" stroke-width="1.5" stroke-dasharray="3 2"/>';
    }
    svg += '<text x="160" y="338" text-anchor="middle" fill="#53657b" font-size="11" font-family="Arial,sans-serif">' + (back ? 'BACK VIEW' : 'FRONT VIEW') + '</text></svg>';
    var figure = root.querySelector('[data-guide-figure]');
    figure.innerHTML = svg;
    figure.firstElementChild.setAttribute('aria-label', placement.name + ' placement illustration, not to scale. Width ' + format.format(measurement.width) + ' inches; maximum height ' + format.format(measurement.height) + ' inches.');
  }
  function buildTables(root, data) {
    var host = root.querySelector('[data-matrix-tables]');
    [['width', 'Recommended print width (in)'], ['height', 'Maximum print height (in)'], ['offset', 'Placement offset (in): collar, or sleeve hem for sleeves']].forEach(function (definition) {
      var wrap = element('div', 'ldsg__table-wrap');
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', definition[1]);
      var table = element('table', 'ldsg__table');
      table.appendChild(element('caption', '', definition[1]));
      var head = element('thead');
      var row = element('tr');
      var first = element('th', '', 'Print location'); first.scope = 'col'; row.appendChild(first);
      data.sizes.forEach(function (size) { var th = element('th', '', size.id); th.scope = 'col'; row.appendChild(th); });
      head.appendChild(row); table.appendChild(head);
      var body = element('tbody');
      data.placements.forEach(function (placement) {
        var tr = element('tr');
        var th = element('th', '', placement.name); th.scope = 'row'; tr.appendChild(th);
        placement[definition[0]].forEach(function (value) { tr.appendChild(element('td', '', format.format(value))); });
        body.appendChild(tr);
      });
      table.appendChild(body); wrap.appendChild(table); host.appendChild(wrap);
    });
  }
  function mount(root) {
    if (root.dataset.sizeGuideMounted) return;
    root.dataset.sizeGuideMounted = 'true';
    try {
      var data = JSON.parse(root.querySelector('[data-size-matrix]').textContent);
      validate(data);
      var sizeIndex = data.sizes.findIndex(function (size) { return size.id === data.defaultSize; });
      var placementIndex = data.placements.findIndex(function (placement) { return placement.id === data.defaultPlacement; });
      if (sizeIndex < 0) sizeIndex = 0;
      if (placementIndex < 0) placementIndex = 0;
      var sizeButtons = [];
      var placeButtons = [];
      function render(announce) {
        var placement = data.placements[placementIndex];
        var size = data.sizes[sizeIndex];
        var measurement = { width: placement.width[sizeIndex], height: placement.height[sizeIndex], offset: placement.offset[sizeIndex] };
        sizeButtons.forEach(function (button, index) { button.setAttribute('aria-pressed', String(index === sizeIndex)); });
        placeButtons.forEach(function (button, index) { button.setAttribute('aria-pressed', String(index === placementIndex)); });
        root.querySelector('[data-result-title]').textContent = placement.name;
        root.querySelector('[data-result-size]').textContent = size.label;
        root.querySelector('[data-result-width]').textContent = format.format(measurement.width);
        root.querySelector('[data-result-height]').textContent = format.format(measurement.height);
        root.querySelector('[data-result-offset]').textContent = format.format(measurement.offset);
        var offsetLabel = placement.offsetReference === 'sleeve_hem' ? 'Up from sleeve hem' : 'Down from collar';
        root.querySelector('[data-offset-label]').textContent = offsetLabel;
        root.querySelector('[data-result-tip]').textContent = placement.tip;
        draw(root, placement, measurement);
        if (announce) root.querySelector('[data-guide-status]').textContent = size.label + ', ' + placement.name + ': width ' + format.format(measurement.width) + ' inches, maximum height ' + format.format(measurement.height) + ' inches, ' + offsetLabel.toLowerCase() + ' ' + format.format(measurement.offset) + ' inches.';
      }
      data.sizes.forEach(function (size, index) {
        var button = element('button', 'ldsg__option', size.id);
        button.type = 'button';
        button.dataset.guideSize = size.id;
        button.setAttribute('aria-label', size.label);
        button.addEventListener('click', function () { sizeIndex = index; render(true); });
        root.querySelector('[data-size-options]').appendChild(button);
        sizeButtons.push(button);
      });
      data.placements.forEach(function (placement, index) {
        var button = element('button', 'ldsg__option', placement.name);
        button.type = 'button';
        button.dataset.guidePlace = placement.id;
        button.addEventListener('click', function () { placementIndex = index; render(true); });
        root.querySelector('[data-place-options]').appendChild(button);
        placeButtons.push(button);
      });
      buildTables(root, data);
      render(false);
      root.querySelector('[data-guide-controls]').hidden = false;
    } catch (error) {
      root.querySelector('[data-guide-controls]').hidden = true;
      root.querySelector('[data-guide-error]').hidden = false;
      root.dataset.sizeGuideError = 'true';
    }
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-ldtf-size-guide]')) mount(scope);
    scope.querySelectorAll('[data-ldtf-size-guide]').forEach(mount);
  }
  window.LionDTFSizeGuide = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
